import React from 'react';
import ConfirmAccountDetailsForm from '../components/Auth/ConfirmAccountDetails';

const ConfirmAccountDetails = () => <ConfirmAccountDetailsForm />;

export default ConfirmAccountDetails;